import type { PaginatedQueryParams } from 'queries/queries-utils'
import type {
  ReliabilityTestsPreviewQueryParams,
  ReliabilityTestsRunsQueryParams
} from 'queries/reliability-tests/types'
import type { UseGetReliabilityTestRunsByIdOptions } from 'queries/reliability-tests/use-get-reliability-test-runs-by-id'

export const reliabilityTestsQueryKeys = {
  getById: ({
    reliabilityTestId,
    ...params
  }: {
    teamId: string
    reliabilityTestId: string
  }) => [`reliability-tests/${reliabilityTestId}`, params] as const,
  getActivePaged: (params: { teamId: string } & PaginatedQueryParams) =>
    ['reliability-tests/active/paged', params] as const,
  getCompletedPaged: (params: { teamId: string } & PaginatedQueryParams) =>
    ['reliability-tests/completed/paged', params] as const,
  getPreview: (params: ReliabilityTestsPreviewQueryParams) =>
    ['reliability-tests/preview', params] as const,
  getReliabilityTestRunsById: ({
    reliabilityTestId,
    ...query
  }: UseGetReliabilityTestRunsByIdOptions & { teamId: string }) =>
    [`reliability-tests/${reliabilityTestId}/runs`, query] as const
}

export const reliabilityTestsMutationKeys = {
  postReliabilityTestsRuns: ({
    reliabilityTestId,
    ...params
  }: ReliabilityTestsRunsQueryParams) =>
    [`reliability-tests/${reliabilityTestId}/runs`, params] as const
}
